export default __webpack_public_path__ + "static/media/Brody_Oil_Painting.51a633eb.JPG";